import React from "react";
import { Button } from "antd";
import { IS_DEV, IS_UAT } from "../../config";
import { useModal } from "../../cro/context/CroModalContext";
import { btnStyle } from "../../cro/styles/buttonStyles";
import { useTranslation } from "react-i18next";

interface InvalidZipcodeProps {
  setUserZipCode?: React.Dispatch<React.SetStateAction<string | null>>;
}

const InvalidZipcode: React.FC<InvalidZipcodeProps> = ({ setUserZipCode }) => {
  const { hideModal } = useModal();
  const { t } = useTranslation("cro");
  return (
    <div style={{ padding: "2rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 8,
          marginTop: 5,
        }}
      >
        <Button
          style={btnStyle}
          onClick={() => {
            window.location.href = `https://${
              IS_DEV ? "dev-signup" : IS_UAT ? "uat-signup" : "signup"
            }.cleanskyenergy.com/`;
          }}
        >
          {t("Back to Sign up")}
        </Button>
        <Button
          style={btnStyle}
          onClick={() => {
            if (setUserZipCode) {
              setUserZipCode(null);
            }
            hideModal();
          }}
        >
          {t("Close")}
        </Button>
      </div>
    </div>
  );
};

export default InvalidZipcode;
